export const agreementTypeMixin = {
  methods: {
    agreementType(agreement) {
      let agreementType;

      switch (agreement) {
        case 0:
          agreementType = 'Advertising';
          break;

        case 1:
          agreementType = 'Recruiting';
          break;

        case 2:
          agreementType = 'Internal';
          break;

        default:
          agreementType = -1;
          break;
      }

      return agreementType;
    },
  },
};
